import api from '../api/axiosInstance';

export const enmService = {
  getAll: () => api.get('/api/enm'),
};
